<!-- PlaylistPickerModal.vue – Modal for attaching existing playlists to product -->
<template>
  <b-modal
      :visible="visible"
      size="lg"
      title="پیوست پلی‌لیست به محصول"
      hide-footer
      header-bg-variant="light"
      @hidden="reset"
  >
    <!-- Playlist List -->
    <div v-if="loading" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">در حال بارگذاری...</span>
      </div>
    </div>

    <div v-else-if="playlists.length === 0" class="text-center py-4">
      <feather-icon icon="ListIcon" size="40"></feather-icon>
      <p class="mt-2">هیچ پلی‌لیستی در کتابخانه یافت نشد.</p>
    </div>

    <b-row v-else>
      <b-col
          v-for="playlist in playlists"
          :key="playlist.id"
          cols="12"
          sm="6"
          md="4"
          class="mb-3"
      >
        <b-card
            class="playlist-picker-card"
            :class="{ selected: selectedPlaylistId === playlist.id }"
            @click="toggleSelection(playlist.id)"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="mb-0 font-weight-bold">{{ playlist.title }}</h6>
              <div class="playlist-meta text-muted small">
                <span>{{ playlist.items ? playlist.items.length : 0 }} ویدیو</span>
                <span class="mx-1">·</span>
                <span>{{ playlist.isActive ? 'فعال' : 'غیرفعال' }}</span>
              </div>
            </div>
            <div v-if="selectedPlaylistId === playlist.id" class="selected-check">
              <i class="fas fa-check-circle text-primary"></i>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <div class="w-100 d-flex justify-content-between align-items-center mt-3">
      <b-button variant="outline-secondary" @click="hide">
        لغو
      </b-button>
      <b-button
          variant="primary"
          @click="attachPlaylist"
          :disabled="!selectedPlaylistId || attaching"
      >
        <i v-if="attaching" class="fas fa-spinner fa-spin"></i>
        پیوست پلی‌لیست
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {BButton, BCard, BCardBody, BCol, BModal, BRow} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import {ProductMediaPlaylistsAttachRequest} from '@/libs/Api/ProductMedia'
import {PlaylistGetByOwnerRequest} from "@/libs/Api/Playlist";

export default {
  name: 'PlaylistPickerModal',
  components: {
    BModal,
    BButton,
    BRow,
    BCol,
    BCard,
    BCardBody,
  },
  props: {
    productId: {
      type: Number | String,
      required: true
    }
  },
  data: function () {
    return {
      visible: false,
      loading: false,
      attaching: false,
      playlists: [],
      selectedPlaylistId: null,
    }
  },
  computed: {
    hasSelection: function () {
      return this.selectedPlaylistId !== null
    },
  },
  methods: {
    showToast: function (variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'bottom-center',
        props: {
          title: title,
          icon: variant === 'success' ? 'CheckIcon' : 'XIcon',
          variant: variant,
          text: text
        }
      })
    },

    show: function () {
      this.visible = true
      this.selectedPlaylistId = null
      this.fetchPlaylists()
    },
    hide: function () {
      this.visible = false
    },
    reset: function () {
      this.attaching = false
      this.selectedPlaylistId = null
    },

    fetchPlaylists: function () {
      var self = this
      self.loading = true
      var request = new PlaylistGetByOwnerRequest(this)
      request.setParams({ownerType: 1, ownerId: 1})
      request.fetch(
          function (content) {
            self.playlists = content || []
            self.loading = false
          },
          function (error) {
            self.loading = false
            self.showToast('error', 'خطا در بارگذاری پلی‌لیست‌ها', error.message)
          }
      )
    },

    toggleSelection: function (playlistId) {
      if (this.selectedPlaylistId === playlistId) {
        this.selectedPlaylistId = null
      } else {
        this.selectedPlaylistId = playlistId
      }
    },

    attachPlaylist: function () {
      if (!this.selectedPlaylistId) return

      var self = this
      self.attaching = true
      var request = new ProductMediaPlaylistsAttachRequest(this)
      request.setParams({
        playlistId: this.selectedPlaylistId,
        productId: this.productId,
      })
      request.fetch(
          function () {
            self.attaching = false
            self.hide()
            self.$emit('attached')
            self.showToast('success', 'موفق', 'پلی‌لیست با موفقیت به محصول پیوست شد.')
          },
          function (error) {
            self.attaching = false
            self.showToast('error', 'خطا', error.message || 'خطا در پیوست پلی‌لیست')
          }
      )
    }
  }
}
</script>

<style scoped>
.playlist-picker-card {
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  transition: all 0.2s ease;
  cursor: pointer;
}

.playlist-picker-card:hover {
  border-color: #94a3b8;
  transform: translateY(-2px);
}

.playlist-picker-card.selected {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.selected-check {
  font-size: 24px;
}

.playlist-meta {
  font-size: 12px;
  color: #94a3b8;
}
</style>
